export interface TextFieldProps {
  id?: string;
  name: string;
  icon?: string;
  label?: string;
  validations?: any;
  placeholder?: string;
  type?: string;
  autoComplete?: string;
  showLabel?: boolean;
  required?: boolean;
  onChange?: Function;
  error?: boolean;
  errorText?: String;
  autoFocus?: boolean;
}

export default function TextField({
  id,
  name,
  icon,
  label,
  type,
  validations,
  autoComplete,
  placeholder,
  showLabel,
  required,
  onChange,
  error,
  errorText,
  autoFocus,
}: TextFieldProps) {
  let isDate = validations?.isDate;
  return (
    <div className="text-left w-full">
      <div className={`text-sm mb-2 ${!label || !showLabel ? "hidden" : null}`}>
        <label
          id={[name, "label"].join("-")}
          htmlFor={[name, "input"].join("-")}
        >
          {label}
        </label>
      </div>
      <div className={`text-left rounded-text-field h-16 relative`}>
        {icon ? (
          <div className="absolute" style={{ left: "24px", top: "20px" }}>
            <div className="w-5 h-5 flex items-center">
              <img src={icon} />
            </div>
          </div>
        ) : null}
        <input
          className={`h-full w-full rounded-text-field ${
            icon ? "pl-16" : "pl-8"
          } pr-8 border ${
            error ? "border-red-500" : "border-gray-300"
          }  focus:ring-0 ${
            error ? "focus:border-red-500" : "focus:border-primary"
          }`}
          autoComplete={
            process.env.NODE_ENV === "production" ? "off" : autoComplete
          }
          id={[id || name, "input"].join("-")}
          name={name}
          placeholder={placeholder}
          required={required}
          type={type}
          autoFocus={autoFocus}
          onChange={onChange ? (e) => onChange(e.target.value, id) : () => null}
        />
      </div>
      {error ? <p className="mt-1 text-xs text-red-500">{errorText}</p> : null}
    </div>
  );
}
